import React from 'react';
import Modal from 'react-bootstrap/Modal'
import {useDispatch, useSelector} from "react-redux";
import {deleteMachine, setDeleteMachineId} from "../../actions/machine";

const MachineDeleteForm = () => {

    const dispatch = useDispatch();

    const {delete_machine_id, currentPage, numberOfPages, machines} = useSelector(state => state.machine);

    const closeModal = () => {
        // removing machine from redux state by sending null setDeleteMachineId
        dispatch(setDeleteMachineId(null))
    };

    let getPage = null;

    const onConfirm = () => {
        if ((currentPage === numberOfPages) && (machines.length === 1)) {
            getPage = (currentPage - 1);
        }
        else {
            getPage = currentPage;
        }
        dispatch(deleteMachine(delete_machine_id, getPage))
    };

    let condition = false;
    if (delete_machine_id !== null)
        condition = true;

    return (
        <div>
            <Modal show={condition} onHide={closeModal}>
                <Modal.Header className="bg-danger" closeButton>
                    <Modal.Title className="text-white">Uskunani o'chirish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Siz haqiqatdan ham ushbu uskunani o'chirmoqchimisiz?
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={closeModal} className="btn btn-secondary">YO'Q</button>
                    <button onClick={onConfirm} className="btn btn-primary">HA</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default MachineDeleteForm; 